module.exports = __webpack_public_path__ + "./img/type_your_targets_thumb.png";